import { useEffect, useState } from "react";

const useScript = (url, isPageReady) => {
  const [script, setScript] = useState(null);
  useEffect(() => {
    setScript(document.createElement("script"));
  }, []);
  useEffect(() => {
    return setTimeout(() => {
      if (script !== null) {
        script.src = url;
        script.async = true;

        document.body.appendChild(script);

        return () => {
          document.body.removeChild(script);
        };
      }
    }, 3500);
  }, [isPageReady === "complete" || isPageReady === "interactive", url]);
};

export default useScript;
